import { UserLogon } from '@/data/Content/Login';
import { useNotifications } from '@/data/Content/Notifications';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useLocalization } from '@/data/Localization';
import { ErrorType } from '@/data/types/Error';
import { useEffect, useRef } from 'react';

const PASSWORD_EXPIRED_MODAL_TITLE = 'Contraseña expirada';
const PASSWORD_EXPIRED_MODAL_MESSAGE =
	'Por seguridad, es necesario actualizar tu contraseña, ya que ha expirado. Crea una nueva contraseña para continuar y acceder nuevamente a tu cuenta.';

type PasswordExpiredState = (ErrorType & { user: UserLogon }) | null;

export const usePasswordExpiredRedirect = (
	passwordExpired: PasswordExpiredState,
	setPasswordExpired: (value: PasswordExpiredState) => void,
	onClose?: () => Promise<void> | void
) => {
	const router = useNextRouter();
	const { notifyError } = useNotifications();
	const RouteLocal = useLocalization('Routes');
	const onCloseRef = useRef(onClose);
	onCloseRef.current = onClose;

	useEffect(() => {
		if (passwordExpired === null) {
			return;
		}
		const expiredLogonId = passwordExpired.user?.logonId || passwordExpired.user?.email || '';
		setPasswordExpired(null);
		notifyError(PASSWORD_EXPIRED_MODAL_MESSAGE, PASSWORD_EXPIRED_MODAL_TITLE);
		void onCloseRef.current?.();
		router.push({
			pathname: RouteLocal.ForgotPassword.route.t(),
			...(expiredLogonId ? { query: { email: expiredLogonId } } : {}),
		});
	}, [passwordExpired, setPasswordExpired, notifyError, router, RouteLocal]);
};
